const origin = /local/.test(window.location.hostname) ? 'http://test-www.ylhglobal.com' : window.location.origin;
// 从 origin 中提取主域名
const extractMainDomain = (url: string): string => {
  try {
    const hostname = new URL(url).hostname;
    const parts = hostname.split('.');
    // 如果是 test-www.ylhglobal.com 或 serafino.co 格式，提取后两部分
    if (parts.length >= 2) {
      return parts.slice(-2).join('.');
    }
    return hostname;
  } catch {
    return '';
  }
};

// 只保留二级域名 例如 xx.qq.com ->  qq.com
const mainDomain = extractMainDomain(origin);
const allWebsite = {
  test: {
    monetization: `${origin}/publisher?from=official`,
    userGrowth: `//test-sso.${mainDomain}/dashboard/delivery`,
    privacyPolicy: `${origin}/privacy/privacypolicy.html`,
    yourPrivacyChoices: `${origin}/privacy/privacychoices.html`,
    cookiePolicy: `${origin}/privacy/cookiepolicy.html`,
    docsBaseUrl: `${origin}/publisher/sdk/docs/`,
    staticBaseUrl: 'https://sdkstatic.adsurge.com',
  },
  production: {
    monetization: `${origin}/publisher?from=official`,
    userGrowth: `//sso.${mainDomain}/dashboard/delivery`,
    privacyPolicy: `${origin}/privacy/privacypolicy.html`,
    yourPrivacyChoices: `${origin}/privacy/privacychoices.html`,
    cookiePolicy: `${origin}/privacy/cookiepolicy.html`,
    docsBaseUrl: 'https://sdkstatic.adsurge.com/sdk/docs/',
    staticBaseUrl: 'https://sdkstatic.adsurge.com',
  },
};
const website = /(test|local)/.test(window.location.href) ? allWebsite.test : allWebsite.production;

export default website;